import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CloudSyncIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cloud_sync"}/>
}
